import React from 'react';
import capitalize from 'lodash/capitalize';
import { PapiUser } from '@wix/da-papi-types';
import UserGrid from '../../_partials/UserGrid';

import s from './Admins.scss';

export interface Props {
  moduleId: number;
  isOwner: boolean;
  profileOwnerUser?: PapiUser;
  username: string;
  roles: {
    name: string;
    typeId: number;
  }[];
  results: {
    typeId: number;
    user: PapiUser;
  }[];
  isHeaderStickyOnMobile?: boolean;
}

export const Admins: React.FC<Props> = ({ roles = [], results = [] }) => {
  return (
    <>
      {roles.map(({ typeId: roleId, name }) => {
        const users = results
          .filter(({ typeId }) => typeId === roleId)
          .map(({ user }) => user);
        if (users.length === 0) {
          return null;
        }
        return (
          <div key={roleId} className={s['role-group']}>
            <h2 className={s['role-title']}>{capitalize(name)}</h2>
            <UserGrid users={users} />
          </div>
        );
      })}
    </>
  );
};

export default Admins;
